import { Form } from 'react-bootstrap'

export function NumberInput({ value, options, onChange, ...otherProps }) {
    return (
        <Form.Group>
            <Form.Control
                type="number"
                pattern="[0-9]*"
                value={value}
                onChange={(e) => {
                    onChange(e)
                }}
                {...otherProps}
            >
            </Form.Control>
        </Form.Group>
    )
}